import { render, staticRenderFns } from "./LeadKanban.vue?vue&type=template&id=22c3f088&"
import script from "./LeadKanban.vue?vue&type=script&lang=js&"
export * from "./LeadKanban.vue?vue&type=script&lang=js&"
import style0 from "./LeadKanban.vue?vue&type=style&index=0&id=22c3f088&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c3f088')) {
      api.createRecord('22c3f088', component.options)
    } else {
      api.reload('22c3f088', component.options)
    }
    module.hot.accept("./LeadKanban.vue?vue&type=template&id=22c3f088&", function () {
      api.rerender('22c3f088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/leads/LeadKanban.vue"
export default component.exports